import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=8ba3b9b4&scoped=true&"
import script from "./VerifyCode.vue?vue&type=script&lang=ts&"
export * from "./VerifyCode.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=8ba3b9b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba3b9b4",
  null
  
)

export default component.exports